import { render, staticRenderFns } from "./shiyong.vue?vue&type=template&id=6561aabd&scoped=true&"
import script from "./shiyong.vue?vue&type=script&lang=js&"
export * from "./shiyong.vue?vue&type=script&lang=js&"
import style0 from "./shiyong.vue?vue&type=style&index=0&id=6561aabd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561aabd",
  null
  
)

export default component.exports